import styled from 'styled-components';

export const CollectionContainer = styled.div`
  display: flex;
  width: 1346px;
  flex-wrap: wrap;
  row-gap: 16px;
  column-gap: 12px;
`;

export const CollectionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CollectionImagesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-radius: 12px;
  border: 1px solid black;
`;

export const CollectionImagesSubContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 104px;
  height: 102px;
`;

export const CollectionTitle = styled.h1`
  font-family: Inter-Medium;
  font-size: 14px;
  color: black;
  line-height: 125%;
`;

export const CollectionSubTitle = styled.h1`
  font-family: Inter-Medium;
  font-size: 12px;
  color: #4D4D4D
`;

export const Image1 = styled.img`
  height: 104px;
  width: 76px;
  border-radius: 12px 0px 0px 12px;
`;

export const Image2 = styled.img`
  height: 52px;
  width: 52px;
`;

export const Image3 = styled.img`
  height: 50px;
  width: 50px;
  border-radius: 12px 0px 0px 12px;
`;


